import { Mapper } from "../../../../base/utils/mapper";
import { OthersResponseModel } from "../../../../domain/models/consult/other-response.model";
import { OthersResponseEntity } from "../entities/others-response.entity";


export class OthersImplementationRepositoryMapper extends Mapper<OthersResponseEntity, OthersResponseModel> {
    mapFrom(param: OthersResponseEntity): OthersResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: OthersResponseModel): OthersResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}